import { useCallback, useEffect, useState } from "react";
import { GraphQLClient } from "graphql-request";
import { graphqlEndpoint } from "../config";
import { READ_ROLE_ALLOCATION_BOARD } from "../graph/roleAllocation/queries";
import { mapRoleAllocationBoardToDashboard } from "../utils/mapRoleAllocationBoardToDashboard";

const client = new GraphQLClient(graphqlEndpoint);

export default function useRoleCoverageDashboard({
  tenantId,
  departmentId = null,
  viewMode = "ALL",
}) {
  const [rawBoard, setRawBoard] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    if (!tenantId) {
      setRawBoard(null);
      setData(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const variables = {
        input: {
          tenantId,
          departmentId: departmentId || null,
          viewMode,
        },
      };

      const response = await client.request(READ_ROLE_ALLOCATION_BOARD, variables);
      const board = response.readRoleAllocationBoard;

      setRawBoard(board);
      setData(mapRoleAllocationBoardToDashboard(board));
    } catch (err) {
      console.error("Failed to load role coverage dashboard:", err);
      setError(err);
      setRawBoard(null);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [tenantId, departmentId, viewMode]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    rawBoard,
    data,
    loading,
    error,
    refetch: fetchDashboard,
  };
}